import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelRadio as _vModelRadio, withDirectives as _withDirectives, vModelSelect as _vModelSelect, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/user_profile/title.svg'
import _imports_1 from '@/assets/img/user_profile/entry.svg'


const _withScopeId = n => (_pushScopeId("data-v-32d62f4d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "user_profile" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "subTitle" }, [
  /*#__PURE__*/_createTextVNode(" 初回のみ投票者のプロフィールについて"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" お答えください。 ")
], -1))
const _hoisted_4 = { class: "form-area" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "w600" }, "性別", -1))
const _hoisted_6 = { class: "radio-label" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "radio-text" }, "女性", -1))
const _hoisted_8 = { class: "radio-label" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "radio-text" }, "男性", -1))
const _hoisted_10 = { class: "radio-label" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "radio-text" }, "その他", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "w600" }, "年齢", -1))
const _hoisted_14 = { class: "selectWrap" }
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<option value=\"\" disabled selected style=\"display:none;\" data-v-32d62f4d>年代を選択してください。</option><option value=\"10歳以下\" data-v-32d62f4d>10歳以下</option><option value=\"11〜13歳\" data-v-32d62f4d>11〜13歳</option><option value=\"14〜16歳\" data-v-32d62f4d>14〜16歳</option><option value=\"17〜19歳\" data-v-32d62f4d>17〜19歳</option><option value=\"20〜29歳\" data-v-32d62f4d>20〜29歳</option><option value=\"30〜39歳\" data-v-32d62f4d>30〜39歳</option><option value=\"40〜49歳\" data-v-32d62f4d>40〜49歳</option><option value=\"50〜59歳\" data-v-32d62f4d>50〜59歳</option><option value=\"60歳以上\" data-v-32d62f4d>60歳以上</option>", 10)
const _hoisted_25 = [
  _hoisted_15
]
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "w600" }, "居住地", -1))
const _hoisted_28 = { class: "selectWrap" }
const _hoisted_29 = /*#__PURE__*/_createStaticVNode("<option value=\"\" disabled selected style=\"display:none;\" data-v-32d62f4d>居住地を選択してください。</option><option value=\"北海道\" data-v-32d62f4d>北海道</option><option value=\"青森県\" data-v-32d62f4d>青森県</option><option value=\"岩手県\" data-v-32d62f4d>岩手県</option><option value=\"宮城県\" data-v-32d62f4d>宮城県</option><option value=\"秋田県\" data-v-32d62f4d>秋田県</option><option value=\"山形県\" data-v-32d62f4d>山形県</option><option value=\"福島県\" data-v-32d62f4d>福島県</option><option value=\"茨城県\" data-v-32d62f4d>茨城県</option><option value=\"栃木県\" data-v-32d62f4d>栃木県</option><option value=\"群馬県\" data-v-32d62f4d>群馬県</option><option value=\"埼玉県\" data-v-32d62f4d>埼玉県</option><option value=\"千葉県\" data-v-32d62f4d>千葉県</option><option value=\"東京都\" data-v-32d62f4d>東京都</option><option value=\"神奈川県\" data-v-32d62f4d>神奈川県</option><option value=\"新潟県\" data-v-32d62f4d>新潟県</option><option value=\"富山県\" data-v-32d62f4d>富山県</option><option value=\"石川県\" data-v-32d62f4d>石川県</option><option value=\"福井県\" data-v-32d62f4d>福井県</option><option value=\"山梨県\" data-v-32d62f4d>山梨県</option><option value=\"長野県\" data-v-32d62f4d>長野県</option><option value=\"岐阜県\" data-v-32d62f4d>岐阜県</option><option value=\"静岡県\" data-v-32d62f4d>静岡県</option><option value=\"愛知県\" data-v-32d62f4d>愛知県</option><option value=\"三重県\" data-v-32d62f4d>三重県</option><option value=\"滋賀県\" data-v-32d62f4d>滋賀県</option><option value=\"京都府\" data-v-32d62f4d>京都府</option><option value=\"大阪府\" data-v-32d62f4d>大阪府</option><option value=\"兵庫県\" data-v-32d62f4d>兵庫県</option><option value=\"奈良県\" data-v-32d62f4d>奈良県</option><option value=\"和歌山県\" data-v-32d62f4d>和歌山県</option><option value=\"鳥取県\" data-v-32d62f4d>鳥取県</option><option value=\"島根県\" data-v-32d62f4d>島根県</option><option value=\"岡山県\" data-v-32d62f4d>岡山県</option><option value=\"広島県\" data-v-32d62f4d>広島県</option><option value=\"山口県\" data-v-32d62f4d>山口県</option><option value=\"徳島県\" data-v-32d62f4d>徳島県</option><option value=\"香川県\" data-v-32d62f4d>香川県</option><option value=\"愛媛県\" data-v-32d62f4d>愛媛県</option><option value=\"高知県\" data-v-32d62f4d>高知県</option><option value=\"福岡県\" data-v-32d62f4d>福岡県</option><option value=\"佐賀県\" data-v-32d62f4d>佐賀県</option><option value=\"長崎県\" data-v-32d62f4d>長崎県</option><option value=\"熊本県\" data-v-32d62f4d>熊本県</option><option value=\"大分県\" data-v-32d62f4d>大分県</option><option value=\"宮崎県\" data-v-32d62f4d>宮崎県</option><option value=\"鹿児島県\" data-v-32d62f4d>鹿児島県</option><option value=\"沖縄県\" data-v-32d62f4d>沖縄県</option>", 48)
const _hoisted_77 = [
  _hoisted_29
]
const _hoisted_78 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "notice" }, [
  /*#__PURE__*/_createTextVNode(" TBSでは、投票結果の統計データを作成する目的で、性別、年齢、居住地をお伺いしています。統計データは、個人を特定できないよう加工して作成いたします。 "),
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://www.tbsholdings.co.jp/tbstv/privacy/net.html",
      target: "_blank",
      class: "grad-font"
    }, "TBSのインターネットの個人情報保護について")
  ])
], -1))
const _hoisted_79 = ["disabled"]
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_1 }, null, -1))
const _hoisted_81 = [
  _hoisted_80
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _createElementVNode("label", _hoisted_6, [
        _withDirectives(_createElementVNode("input", {
          type: "radio",
          name: "gender",
          value: "女性",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.gender) = $event))
        }, null, 512), [
          [_vModelRadio, _ctx.gender]
        ]),
        _hoisted_7
      ]),
      _createElementVNode("label", _hoisted_8, [
        _withDirectives(_createElementVNode("input", {
          type: "radio",
          name: "gender",
          value: "男性",
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.gender) = $event))
        }, null, 512), [
          [_vModelRadio, _ctx.gender]
        ]),
        _hoisted_9
      ]),
      _createElementVNode("label", _hoisted_10, [
        _withDirectives(_createElementVNode("input", {
          type: "radio",
          name: "gender",
          value: "その他",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.gender) = $event))
        }, null, 512), [
          [_vModelRadio, _ctx.gender]
        ]),
        _hoisted_11
      ]),
      _hoisted_12,
      _hoisted_13,
      _createElementVNode("div", _hoisted_14, [
        _withDirectives(_createElementVNode("select", {
          name: "age",
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.age) = $event))
        }, _hoisted_25, 512), [
          [_vModelSelect, _ctx.age]
        ])
      ]),
      _hoisted_26,
      _hoisted_27,
      _createElementVNode("div", _hoisted_28, [
        _withDirectives(_createElementVNode("select", {
          name: "address",
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.address) = $event))
        }, _hoisted_77, 512), [
          [_vModelSelect, _ctx.address]
        ])
      ])
    ]),
    _hoisted_78,
    _createElementVNode("button", {
      class: "entryBtn",
      disabled: _ctx.entryBtnEnable,
      onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.sendProfile && _ctx.sendProfile(...args)))
    }, _hoisted_81, 8, _hoisted_79)
  ]))
}